export default __webpack_public_path__ + "media/images/banner-logo-hover-ce20dafb7c59aee35f1c4a93d0e27804.png";